<script lang="ts" setup>
import type { OrderLineItem } from "@shopware-pwa/types";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import SharedPrice from "~/templates/components/shop/shared/SharedPrice.vue";

export interface OrderLineItemExchangeBoxChildrenProps {
  lineItem: OrderLineItem;
}

const props = defineProps<OrderLineItemExchangeBoxChildrenProps>();

const { lineItem } = toRefs(props);

const filling = computed(() => lineItem?.value?.children?.[0]);
const deposit = computed(() => lineItem?.value?.children?.[1]);
</script>

<template>
  <div class="contents text-sm">
    <div class="col-start-2">
      <!-- FILLING-->
      <CommonLabel path="BWF/shop/checkout/cart/exchangeBoxItem/fillingLabel" />&nbsp;<CommonLabel
        :placeholder="{ amountCylinders: filling?.payload?.amountCylinders }"
        path="BWF/shop/checkout/cart/exchangeBoxItem/quantifierLabel"
      />
      <br />
      <!-- DEPOSIT-->
      <CommonLabel path="BWF/shop/checkout/includes" /> {{ deposit?.label }}&nbsp;<CommonLabel
        :placeholder="{ amountCylinders: filling?.payload?.amountCylinders }"
        path="BWF/shop/checkout/cart/exchangeBoxItem/quantifierLabel"
      />
    </div>
    <div class="justify-self-end xl:col-start-4">
      <!-- FILLING-->
      <SharedPrice :value="filling?.totalPrice" has-asterisk />
      <br />
      <!-- DEPOSIT -->
      <SharedPrice :value="deposit?.totalPrice" has-asterisk />
    </div>
  </div>
</template>
